import { useState } from "react"

import { DialogProps, DialogState } from "@/dialogs"

function useDialogState<TDialogState extends DialogState = DialogState>(
  initialState: TDialogState
) {
  const [dialogState, setDialogState] = useState<
    TDialogState & Pick<DialogProps, "isOpen">
  >({
    ...initialState,
    isOpen: false,
  })

  function openDialog(newDialogState: TDialogState) {
    setDialogState({ ...newDialogState, isOpen: true })
  }

  function closeDialog() {
    setDialogState((currentState) => ({ ...currentState, isOpen: false }))
  }

  return { openDialog, closeDialog, ...dialogState }
}

export default useDialogState
